import React, {createContext, useState} from "react";
export const UserContext = createContext();
export const UserProvider = ({children}) => {
    const [userDetails, setUserDetails] = useState({
        name: '',
        place: '',
        photo: null,
    });

    return (
        <UserContext.Provider value={{userDetails,setUserDetails}}>
            {children}
        </UserContext.Provider>
    );
};